export default __webpack_public_path__ + "static/img/plane-arrival.b33c10d.png";